<app-race-share-success-handling [source]="'APP_STORE_REDIRECT'"></app-race-share-success-handling>
